<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入卡号/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
       <span style="margin-right:16px;float: right;">总余额：<span style="color: #66b1ff;font-size: 16px;">￥{{totalBalance}}</span></span>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" label="实体卡号">
              <template slot-scope="scope">
                <span>{{ scope.row.cardno }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="余额">
              <template slot-scope="scope">
                <span>{{ scope.row.balance }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="250px" label="会员名称">
              <template slot-scope="scope">
                <span>{{ scope.row.nickname || scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.mobile }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="级别">
              <template slot-scope="scope">
                <span>{{ scope.row.level === "1"? 'VIP' : scope.row.level === "0"? '普通会员' : '' }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="性别">
              <template slot-scope="scope">
                <span>{{ scope.row.sex === "1"? '女' : scope.row.sex === "0"? '男' : '' }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="身份证号">
              <template slot-scope="scope">
                <span>{{ scope.row.idnumber }} </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="积分">
              <template slot-scope="scope">
                <span>{{ scope.row.score }} </span>
              </template>
            </el-table-column> -->
            <el-table-column align="center" label="操作" min-width="100">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row.id)"  size="mini">
                  <span>扣款</span>
                </el-button>
              </template>
            </el-table-column>
           <!-- <el-table-column align="center" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime }} </span>
              </template>
            </el-table-column> -->
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page"  :total="total">
      </el-pagination>
    </el-container>
  </el-container>
</template>
<script>
import { searchList, physicalcardSpend } from '@/views/webpc/CashierDesk/CardManagementApp/apis'
export default {
  data () {
    return {
      pageSize: 20,
      page: 1,
      total: 0,
      valueid: '',
      tableData: [],
      totalBalance: 0
    }
  },
  methods: {
    // 验证记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      searchList(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
            this.totalBalance = result.data.total_balance
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    // 扣款
    getMdifySpend (mid, amount) {
      let data = new FormData()
      data.append('id', mid)
      data.append('amount', amount)
      physicalcardSpend(data).then((result) => {
        if (result) {
          this.loadData()
          this.$message({
            type: 'success',
            message: '扣款成功!'
          })
        }
      })
    },
    handleEdit (mid) {
      this.$prompt('请输入金额', '扣款金额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^([1-9]\d*(\.\d*)?)$|^0\.\d*[1-9]\d*$/,
        inputErrorMessage: '金额格式不正确'
      })
        .then(({ value }) => {
          this.getMdifySpend(mid, value)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    }
  },
  mounted () {
    this.loadData()
  },
  created () {
    // let shop = window.location.hostname.split('.')[0]
    // if (shop !== 'localhost') {
    //   this.$router.push('/cardManagement')
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CardManagementApp/CardManagementAnother.vue